/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Sdwirtschaft12Inputs */

const en__field_enum_sdwirtschaft12 = /** @type {(inputs: _Field_Enum_Sdwirtschaft12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`02 - Wirtschaftswissenschaften`)
};

const de__field_enum_sdwirtschaft12 = /** @type {(inputs: _Field_Enum_Sdwirtschaft12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`02 - Wirtschaftswissenschaften`)
};

/**
* | output |
* | --- |
* | "02 - Wirtschaftswissenschaften" |
*
* @param {_Field_Enum_Sdwirtschaft12Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_sdwirtschaft12 = /** @type {((inputs?: _Field_Enum_Sdwirtschaft12Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Sdwirtschaft12Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_sdwirtschaft12(inputs)
	return de__field_enum_sdwirtschaft12(inputs)
});
export { _field_enum_sdwirtschaft12 as "_field_enum_SDWIRTSCHAFT" }